import BandedResponse from "pages/PreviewPage/BandedResponse/BandedResponse";

export default BandedResponse;
